<template>
	<div class="col-xs-12">
		<div class="row row-no-gutters" :class="{'margin-top-5': stepNumber > 1}">
			<div class="col-md-12">
				<p class="notification-step" style="color: #FFFFFF">
					<span class="medium-text">
						<h3 style="display: inherit;">
							<strong v-html="getStepNumber()"></strong>
						</h3>
					</span>
					Every contact method you select in this step will happen <b>simultaneously.</b>
				</p>
			</div>
		</div>
		<!-- Headings panel start -->
		<div class="row row-no-gutters step-panel">
			<div class="col-md-4">
				<div class="panel-heading-notification">
					<font-awesome-icon icon="envelope"></font-awesome-icon>
					&emsp;
					<b>{{ emailText }}</b>
				</div>
			</div>
			<div class="col-md-4">
				<div class="panel-heading-notification">
					<font-awesome-icon icon="sms"></font-awesome-icon>
					&emsp;
					<b>{{ smsTextMessage }}</b>
				</div>
			</div>
			<div class="col-md-4">
				<div class="panel-heading-notification">
					<font-awesome-icon icon="phone"></font-awesome-icon>
					&emsp;
					<b>{{ voiceCallText }}</b>
				</div>
			</div>
		</div>
		<!-- Headings panel end -->
		<!-- Contents panel -->
		<div class="row row-no-gutters step-panel" :key="loaded">
			<!-- Email start -->
			<div class="col-md-4 text-center">
				<div class="row step-panel"
						 v-for="(email, emailIndex) in getEmails()"
						 :key="`emailAction_${emailIndex}`">
					<div class="col-xs-12">
						<div class="panel-body-notification">
							<div class="col-xs-10 text-left">
								<label>{{ contactAtText }}</label>
							</div>
							<div class="col-xs-2 text-right">
								<font-awesome-icon icon="times"
																	 style="cursor: pointer;"
																	 @click="removeStep(email)">
								</font-awesome-icon>
							</div>
							<select class="form-control" v-model="email.WORKFLOW_STEP_SOURCE" @change="$emit('updateChange')">
								<option value=""></option>
								<template v-for="(source, sourceIndex) in emailSources">
									<option :value="source.SOURCE_CODE"
													:v-if="source.SOURCE_TYPE === 'email'"
													:key="`email_source_${sourceIndex}`">
										{{ source.SOURCE_DESC }}
									</option>
								</template>
							</select>
						</div>
					</div>
				</div>
				<div class="row step-panel">
					<div class="col-xs-12">
						<div class="panel-body-notification">
							<button class="btn btn-primary bg-blue" @click.prevent="addEmail">
								<font-awesome-icon icon="plus"></font-awesome-icon>&emsp;{{ addEmailText }}
							</button>
						</div>
					</div>
				</div>
			</div>
			<!-- Email end -->
			<!-- SMS start -->
			<div class="col-md-4 text-center">
				<div class="row step-panel"
						 v-for="(sms, smsIndex) in getSMS()"
						 :key="`smsAction_${smsIndex}`">
					<div class="col-xs-12">
						<div class="panel-body-notification">
							<div class="col-xs-10 text-left">
								<label>{{ contactAtText }}</label>
							</div>
							<div class="col-xs-2 text-right">
								<font-awesome-icon icon="times"
																		style="cursor: pointer;"
																		@click="removeStep(sms)">
								</font-awesome-icon>
							</div>
							<select class="form-control" v-model="sms.WORKFLOW_STEP_SOURCE" @change="$emit('updateChange')">
								<option value=""></option>
								<template v-for="(source, sourceIndex) in smsSources">
									<option :value="source.SOURCE_CODE"
													v-if="source.SOURCE_TYPE === 'sms'"
													:key="`sms_source_${sourceIndex}`">
										{{ source.SOURCE_DESC }}
									</option>
								</template>
							</select>
						</div>
					</div>
				</div>
				<div class="row step-panel">
					<div class="col-xs-12">
						<div class="panel-body-notification">
							<button class="btn btn-primary bg-blue" @click.prevent="addSms()">
								<font-awesome-icon icon="plus"></font-awesome-icon>&emsp;{{ addSMSTextMessageText }}
							</button>
						</div>
					</div>
				</div>
			</div>
			<!-- SMS end -->
			<!-- Phone start -->
			<div class="col-md-4 text-center">
				<div class="row step-panel"
						 v-for="(phone, phoneIndex) in getPhone()"
						 :key="`phoneAction_${phoneIndex}`">
					<div class="col-xs-12">
						<div class="panel-body-notification">
							<div class="col-xs-10 text-left">
								<label>{{ contactAtText }}</label>
							</div>
							<div class="col-xs-2 text-right">
								<font-awesome-icon icon="times"
																	style="cursor: pointer;"
																	@click="removeStep(phone)">
								</font-awesome-icon>
							</div>
							<select class="form-control" v-model="phone.WORKFLOW_STEP_SOURCE" @change="$emit('updateChange')">
								<option value=""></option>
								<template v-for="(source, sourceIndex) in phoneSources">
									<option :value="source.SOURCE_CODE"
													:key="`phone_source_${sourceIndex}`">
										{{ source.SOURCE_DESC }}
									</option>
								</template>
							</select>
						</div>
					</div>
				</div>
				<div class="row step-panel" v-if="getPhone().length === 0">
					<div class="col-xs-12">
						<div class="panel-body-notification">
							<button class="btn btn-primary bg-blue" @click.prevent="addPhone()">
								<font-awesome-icon icon="plus"></font-awesome-icon>&emsp;{{ addVoiceCallText }}
							</button>
						</div>
					</div>
				</div>
			</div>
			<!-- Phone end -->
		</div>
		<hr />
	</div>
</template>

<script>
	import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
	import '../../imports/fontAwesome.js';

	export default {
		name: 'StepPanel',
		props: {
			workflow: {
				type:			Object,
				default:	() => {
					return [];
				}
			},
			sources: {
				type:			Array,
				default:	() => {
					return {};
				}
			},
			stepNumber: {
				type:			Number,
				default:	1
			},
			addVoiceCallText: {
				type: String,
				default: "Add Voice Call"
			},
			contactAtText: {
				type: String,
				default: "Contact at"
			},
			addEmailText: {
				type: String,
				default: "Add email"
			},
			emailText: {
				type: String,
				default: "Email"
			},
			smsTextMessage: {
				type: String,
				default: "SMS Text Message"
			},
			addSMSTextMessageText: {
				type: String,
				default: "Add SMS Text Message"
			},
			voiceCallText: {
				type: String,
				default: 'Voice Call'
			}
		},
		data() {
			return {
				loaded: 0
			};
		},
		computed: {
			phoneSources() {
				let phones = [];

				for(let s in this.sources) {
					let source = this.sources[s];

					if(source.SOURCE_TYPE === 'phone') {
						phones.push(source);
					}
				}

				return phones;
			},
			smsSources() {
				let smsMessages = [];

				for(let s in this.sources) {
					let source = this.sources[s];

					if(source.SOURCE_TYPE === 'sms') {
						smsMessages.push(source);
					}
				}

				return smsMessages;
			},
			emailSources() {
				let emails = [];

				for(let e in this.sources) {
					let source = this.sources[e];

					if(source.SOURCE_TYPE === 'email') {
						emails.push(source);
					}
				}

				return emails;
			}
		},
		components: {
			FontAwesomeIcon
		},
		methods: {
			getEmails() {
				let emails = [];

				for(let w in this.workflow.STEPS) {
					let work = this.workflow.STEPS[w];

					if(work.WORKFLOW_STEP_METHOD === 'E') {
						work.INDEX = w;
						emails.push(work);
					}
				}

				return emails;
			},
			getSMS() {
				let sms = [];

				for(let w in this.workflow.STEPS) {
					let work = this.workflow.STEPS[w];

					if(work.WORKFLOW_STEP_METHOD === 'S') {
						sms.INDEX = w;
						sms.push(work);
					}
				}

				return sms;
			},
			getPhone() {
				let phone = [];

				for(let w in this.workflow.STEPS) {
					let work = this.workflow.STEPS[w];

					if(work.WORKFLOW_STEP_METHOD === 'V') {
						phone.INDEX = w;
						phone.push(work);
					}
				}

				return phone;
			},
			addEmail() {
				this.workflow.STEPS.push({
					ACTUAL_STEP_NUMBER: !!this.workflow.ACTUAL_STEP_NUMBER ? this.workflow.ACTUAL_STEP_NUMBER : this.stepNumber,
					WORKFLOW_STEP: !!this.workflow.ACTUAL_STEP_NUMBER ? this.workflow.ACTUAL_STEP_NUMBER : this.stepNumber,
					WORKFLOW_STEP_METHOD: 'E',
					WORKFLOW_STEP_PATH: 'I',
					WORKFLOW_STEP_SOURCE: ''
				});

				this.$emit('updateChange');
			},
			addSms() {
				this.workflow.STEPS.push({
					ACTUAL_STEP_NUMBER: !!this.workflow.ACTUAL_STEP_NUMBER ? this.workflow.ACTUAL_STEP_NUMBER : this.stepNumber,
					WORKFLOW_STEP: !!this.workflow.ACTUAL_STEP_NUMBER ? this.workflow.ACTUAL_STEP_NUMBER : this.stepNumber,
					WORKFLOW_STEP_METHOD: 'S',
					WORKFLOW_STEP_PATH: 'I',
					WORKFLOW_STEP_SOURCE: ''
				});

				this.$emit('updateChange');
			},
			addPhone() {
				this.workflow.STEPS.push({
					ACTUAL_STEP_NUMBER: !!this.workflow.ACTUAL_STEP_NUMBER ? this.workflow.ACTUAL_STEP_NUMBER : this.stepNumber,
					WORKFLOW_STEP: !!this.workflow.ACTUAL_STEP_NUMBER ? this.workflow.ACTUAL_STEP_NUMBER : this.stepNumber,
					WORKFLOW_STEP_METHOD: 'V',
					WORKFLOW_STEP_PATH: 'I',
					WORKFLOW_STEP_SOURCE: ''
				});

				this.$emit('updateChange');
			},
			removeStep(step) {
				for(let s in this.workflow.STEPS) {
					let workflowStep = this.workflow.STEPS[s];

					if(step === workflowStep) {
						this.workflow.STEPS.splice(s, 1);
						break;
					}
				}

				this.$emit('updateChange');
			},
			getStepNumber() {
				switch(this.stepNumber) {
					case 1:
						return '&#x2460;';
						break;
					case 2:
						return '&#x2461;';
						break;
					case 3:
						return '&#x2462;';
						break;
					case 4:
						return '&#x2463;';
						break;
					case 5:
						return '&#x2464;';
						break;
					case 6:
						return '&#x2465;';
						break;
				}
			}
		},
		mounted() {
			this.loaded++;
		}
	}
</script>
